define('orb/features/_cookieprompt', ['orb/lib/_script', 'orb/nav'], function (script, nav) {
    function addCookieBanner(cookiePromptTemplate) {
        var parsedHTML = cookiePromptTemplate.replace(/<<bbcBaseUrl>>/g, window.orb.bbcBaseUrl);
        document.getElementById('cookiePrompt').innerHTML = parsedHTML;
    }

    var cssUrl = window.orb.staticHost + "/css/bbccookies.min.css";
    var ukCountryCodes = ["GB", "IM", "JE", "GY"],
        euCountryCodes = ["AT", "BE", "BG", "CY", "CZ", "DE", "DK", "EE", "ES", "EU", "FI", "FR", "GB", "GR", "HU", "HR", "IE", "IT", "LT", "LU", "LV", "MT", "NL", "PL", "PT", "RO", "SE", "SI", "SK"];

    function showCookieBanner(isUK) {
        nav.loadCss(cssUrl, function () {
            var url;

            if (window.orb.lang === 'en' || window.orb.lang === 'cy' || window.orb.lang === 'gd' || window.orb.lang === 'ga') {
                url = window.orb.staticHost + "/cookie-prompt/" + window.orb.lang;
            } else {
                url = window.orb.staticHost + "/cookie-prompt/en"
            }

            if (isUK) {
                url += ".js";
            } else {
                url += "-nonuk-eu.js";
            }

            script.jsonp(url, addCookieBanner, { callbackName: "cookiePrompt" });
            window.bbcuser.resetCookiesPreferences();
        });
    }

    function initCookiePrompt() {
        Promise.all([
            window.bbcuser.hasCookiesEnabled(),
            window.bbcuser.hasSeenCookieBanner(),
            window.bbcuser.getCountry()
        ]).then(function(conditions) {
            var cookiesEnabled = conditions[0],
                seenCookieBanner = conditions[1],
                country = conditions[2] ? conditions[2].toUpperCase() : undefined;

            var isUK = ukCountryCodes.indexOf(country) !== -1,
                isEU = euCountryCodes.indexOf(country) !== -1;

            if (cookiesEnabled && seenCookieBanner) {
                return;
            }

            if (isUK || isEU) {
                showCookieBanner(isUK);
            }
        }).catch(function(error) {
            showCookieBanner(true);
        });
    }

    return initCookiePrompt;
});
